import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-20 bg-gradient-to-br from-teal-600 to-teal-700 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Prêt à commander ?
          </h2>
          <p className="text-xl text-teal-50 mb-10 max-w-2xl mx-auto">
            Rejoignez les centaines d'habitants qui utilisent déjà Localygo pour se faire livrer leurs produits préférés
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <Link 
              to="/commander" 
              className="bg-white text-teal-600 px-8 py-4 rounded-full text-base font-semibold hover:bg-gray-50 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              Commencer ma commande
            </Link>
            <Link 
              to="/livraison" 
              className="bg-teal-800 text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-teal-900 transition-all whitespace-nowrap cursor-pointer"
            >
              Devenir livreur partenaire
            </Link>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="text-center">
              <div className="text-4xl font-bold mb-2">50+</div>
              <div className="text-teal-50">Restaurants partenaires</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold mb-2">30+</div>
              <div className="text-teal-50">Boutiques locales</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold mb-2">5000+</div>
              <div className="text-teal-50">Commandes livrées</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
